import React from 'react';
import { noop } from 'lodash';
import cn from 'classnames';
import { func, bool, node, string, oneOf } from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { l_chevron_down } from '@fiverr-private/icons';
import FilterButton from '../FilterButton';
import useDropdownFilterButton from './hooks/useDropdownFilterButton';

import classes from './index.module.scss';
import { POSITIONS } from './constants';

const DropdownFilterButton = ({
    children,
    dropdown,
    opened: openedProp,
    onOpenedChange = noop,
    filled,
    onClick = noop,
    position = POSITIONS.LEFT,
    color = FilterButton.COLORS.GREEN,
}) => {
    const { opened, handleClick, dropdownRef } = useDropdownFilterButton({
        openedProp,
        onClick,
        onOpenedChange,
    });

    return (
        <div className={classes.dropdownWrapper}>
            <FilterButton
                onClick={handleClick}
                className={classes.filterButton}
                active={opened}
                selected={filled}
                withCheckIcon={false}
                color={color}
            >
                {children}
                <Icon className={classes.filterButtonIcon} size="12">
                    {l_chevron_down}
                </Icon>
            </FilterButton>
            {dropdown && opened && (
                <div
                    ref={dropdownRef}
                    className={cn(classes.dropdownContainer, classes[position])}
                >
                    {dropdown}
                </div>
            )}
        </div>
    );
};

DropdownFilterButton.POSITIONS = POSITIONS;
DropdownFilterButton.COLORS = FilterButton.COLORS;

DropdownFilterButton.propTypes = {
    children: node,
    dropdown: node,
    opened: bool,
    filled: bool,
    onClick: func,
    onOpenedChange: func,
    position: string,
    color: oneOf(FilterButton.COLORS),
};

export default DropdownFilterButton;
